import Image from 'next/image';
import { motion } from 'framer-motion';
import styled from 'styled-components';
export const Container = styled.section.withConfig({
  displayName: "TrendAnimationstyle__Container",
  componentId: "sc-1umulil-0"
})(["", " @media (max-width:", "){", "}"], {
  "paddingBottom": "120px",
  "paddingTop": "4rem",
  "textAlign": "center"
}, ({
  theme
}) => theme.breakpoint.md, {
  "paddingBottom": "2.5rem",
  "paddingTop": "2.5rem"
});
export const TitleWrapper = styled.h1.withConfig({
  displayName: "TrendAnimationstyle__TitleWrapper",
  componentId: "sc-1umulil-1"
})(["", " @media (max-width:", "){", "}"], {
  "marginTop": "1.25rem",
  "marginBottom": "1.25rem",
  "display": "inline-block",
  "borderRadius": "100px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(235 235 235 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "2rem",
  "paddingRight": "2rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "--tw-text-opacity": "1",
  "color": "rgb(88 88 88 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "0.5rem",
  "marginTop": "0px",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem"
});
export const ParallaxContainer = styled.div.withConfig({
  displayName: "TrendAnimationstyle__ParallaxContainer",
  componentId: "sc-1umulil-2"
})(["", ""], {
  "margin": "0px",
  "display": "flex",
  "flexWrap": "nowrap",
  "overflow": "hidden",
  "whiteSpace": "nowrap"
});
export const ParallaxScroller = styled(motion.div).withConfig({
  displayName: "TrendAnimationstyle__ParallaxScroller",
  componentId: "sc-1umulil-3"
})(["", " @media (max-width:", "){", "}"], {
  "display": "flex",
  "flexWrap": "nowrap",
  "gap": "7rem",
  "whiteSpace": "nowrap"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "5rem"
});
export const ContentWrapper = styled.div.withConfig({
  displayName: "TrendAnimationstyle__ContentWrapper",
  componentId: "sc-1umulil-4"
})(["", " @media (max-width:", "){", "}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "1rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "0.5rem"
});
export const ContentIcon = styled(Image).withConfig({
  displayName: "TrendAnimationstyle__ContentIcon",
  componentId: "sc-1umulil-5"
})(["", " @media (max-width:", "){", "}"], {
  "aspectRatio": "1 / 1",
  "width": "72px",
  "objectFit": "contain"
}, ({
  theme
}) => theme.breakpoint.md, {
  "width": "3rem"
});
export const ContentText = styled.p.withConfig({
  displayName: "TrendAnimationstyle__ContentText",
  componentId: "sc-1umulil-6"
})(["", " color:", ";transition:all 0.3s ease-in-out;background-color:", ";@media (max-width:", "){", "}"], {
  "display": "inline-block",
  "cursor": "pointer",
  "borderRadius": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingTop": "0.625rem",
  "paddingBottom": "0.625rem",
  "fontSize": "6rem",
  "lineHeight": "1",
  "fontWeight": "700"
}, ({
  $isHover,
  $color
}) => `${$isHover ? '#ffffff' : $color}`, ({
  $isHover,
  $color
}) => `${$isHover ? $color : 'transparent'}`, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "3rem",
  "lineHeight": "1.25rem"
});
export const TooltipText = styled.span.withConfig({
  displayName: "TrendAnimationstyle__TooltipText",
  componentId: "sc-1umulil-7"
})(["", ""], {
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
});